const firebaseConfig = {
    apiKey: "AIzaSyA8WjXzjecyfjBZC-6bMZ0whNlOWdpUY98",
    authDomain: "techdairy-blog.firebaseapp.com",
    projectId: "techdairy-blog",
    storageBucket: "techdairy-blog.appspot.com",
    messagingSenderId: "28967151977",
    appId: "1:28967151977:web:e1511fabf9ab64ccf5b5f8"
};

export default firebaseConfig;